import { TableRowModel, ViewRowModel } from '@examdojo/supabase';
import { SvgIcon } from '@examdojo/core/icon';
import { SyllabusAndCourseLevel, SyllabusHttpModel } from '../syllabus';
import { CourseLevel } from './course-level.model';

export type CourseMetadata = TableRowModel<'courses', 'categories'>;

export type CourseHttpModel = SyllabusHttpModel &
  ViewRowModel<'syllabuses_with_courses', 'categories'> & {
    course_level: CourseLevel; // TODO: remove when phasing out CourseLevel
  };

export type CourseStoreModel = Omit<CourseHttpModel, 'id'> & {
  syllabus_id: CourseHttpModel['id']; // aliasing the syllabus_id for clarity
  longLabel: string;
  shortLabel: string;
  icon?: SvgIcon;
  compositeId: CourseCompositeId;
};

export type CourseCompositeId = `${SyllabusAndCourseLevel['syllabusId']}-${SyllabusAndCourseLevel['courseLevel']}`;

export function getCourseCompositeId({ syllabusId, courseLevel }: SyllabusAndCourseLevel): CourseCompositeId {
  return `${syllabusId}-${courseLevel}`;
}
